/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_Resize_HandleInputs */

const en_editor_filter_resize_handle = /** @type {(inputs: Editor_Filter_Resize_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag to resize filter panel`)
};

const fr_editor_filter_resize_handle = /** @type {(inputs: Editor_Filter_Resize_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glisser pour redimensionner le panneau de filtres`)
};

const de_editor_filter_resize_handle = /** @type {(inputs: Editor_Filter_Resize_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziehen, um das Filterfeld zu vergrößern`)
};

const it_editor_filter_resize_handle = /** @type {(inputs: Editor_Filter_Resize_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascina per ridimensionare il pannello dei filtri`)
};

const ru_editor_filter_resize_handle = /** @type {(inputs: Editor_Filter_Resize_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перетащите, чтобы изменить размер панели фильтров`)
};

const es_editor_filter_resize_handle = /** @type {(inputs: Editor_Filter_Resize_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrastra para redimensionar el panel de filtros`)
};

const zh_cn2_editor_filter_resize_handle = /** @type {(inputs: Editor_Filter_Resize_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拖动以调整筛选面板大小`)
};

const ja_editor_filter_resize_handle = /** @type {(inputs: Editor_Filter_Resize_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドラッグしてフィルターパネルのサイズを変更`)
};

const hi_editor_filter_resize_handle = /** @type {(inputs: Editor_Filter_Resize_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़िल्टर पैनल का आकार बदलने के लिए खींचें`)
};

const pt_pt2_editor_filter_resize_handle = /** @type {(inputs: Editor_Filter_Resize_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arraste para redimensionar o painel de filtros`)
};

/**
* | output |
* | --- |
* | "Drag to resize filter panel" |
*
* @param {Editor_Filter_Resize_HandleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_resize_handle = /** @type {((inputs?: Editor_Filter_Resize_HandleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_Resize_HandleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_filter_resize_handle(inputs)
	if (locale === "de") return de_editor_filter_resize_handle(inputs)
	if (locale === "it") return it_editor_filter_resize_handle(inputs)
	if (locale === "ru") return ru_editor_filter_resize_handle(inputs)
	if (locale === "es") return es_editor_filter_resize_handle(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_filter_resize_handle(inputs)
	if (locale === "ja") return ja_editor_filter_resize_handle(inputs)
	if (locale === "hi") return hi_editor_filter_resize_handle(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_filter_resize_handle(inputs)
	return en_editor_filter_resize_handle(inputs)
});